'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _IntlProvider = require('./IntlProvider');

var _IntlProvider2 = _interopRequireDefault(_IntlProvider);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Provider = function Provider(_ref) {
    var store = _ref.store,
        children = _ref.children;
    return (0, _jsx3.default)(_reactRedux.Provider, {
        store: store
    }, void 0, (0, _jsx3.default)(_IntlProvider2.default, {}, void 0, children));
};

exports.default = Provider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/IntlRedux/Provider.js
// module id = MPVH
// module chunks = 60